// extracted by mini-css-extract-plugin
export default {"base":"Search_base__aTioJ","input":"Search_input__tHM9E","focus":"Search_focus__cKFNF"};